// from Webamp demo
import { Options } from 'webamp';

export const webampConfig = {
  enableHotkeys: true,
  __enableDevTools: false,
  __customSourceMaps: false,
};

const album = 'Apnea';

export const initialTracks = [
  {
    url:
      'https://pub-70311bb19ca841c09d3a28aca5f1f07d.r2.dev/apnea%20mp3/Apnea%201%20.mp3',
    duration: 180,
    metaData: {
      title: 'Apnea - 1',
      artist: '2 porri',
      album,
    },
  },

  {
    url:
      'https://pub-70311bb19ca841c09d3a28aca5f1f07d.r2.dev/apnea%20mp3/Apnea%202.mp3',
    duration: 200,
    metaData: {
      title: 'Apnea - 2',
      artist: '2 porri',
      album,
    },
  },

  {
    url:
      'https://pub-70311bb19ca841c09d3a28aca5f1f07d.r2.dev/apnea%20mp3/Apnea%203.mp3',
    duration: 240,
    metaData: {
      title: 'Apnea - 3',
      artist: '2 porri',
      album,
    },
  },

  {
    url:
      'https://pub-70311bb19ca841c09d3a28aca5f1f07d.r2.dev/apnea%20mp3/Apnea%204.mp3',
    duration: 220,
    metaData: {
      title: 'Apnea - 4',
      artist: '2 porri',
      album,
    },
  },
];
